import c from "./consts";

export default {
  [c.COMPANY]: null,
  [c.STORM_WARNINGS]: [],
  [c.COMPANY_DISPLAYS]: [],
};